export const itemMixin = {
  data () {
    return {
      active: false,
      childActive: false,
      itemShow: false
    }
  },

  created () {
    this.active = this.item && this.item.href ? this.isLinkActive(this.item) : false
    this.childActive = this.item && this.item.children ? this.isChildActive(this.item.children) : false

    if (this.item && this.item.children) {
      if (this.showChildren) {
        this.itemShow = true
      } else {
        this.itemShow = this.isLinkActive(this.item) || this.isChildActive(this.item.children)
      }
    }
  },

  methods: {
    toggleDropdown () {
      this.itemShow = !this.itemShow
    },

    isLinkActive (item) {
      if (this.$route) {
        return item.href === this.$route.path + this.$route.hash
      } else {
        return item.href === window.location.pathname + window.location.hash
      }
    },

    isChildActive (child) {
      for (let item of child) {
        if (this.isLinkActive(item)) {
          return true
        }

        if (item.children) {
          if (this.isChildActive(item.children)) {
            return true
          }
        }
      }
      return false
    },

    clickEvent (event, collapsedItem) {
      if (this.item.disabled || (collapsedItem && !this.item.href)) {
        event.preventDefault()
        return
      }

      if (this.isCollapsed && this.firstItem) {
        let clearCloseTimeout = this.item.children
        this.$parent.$emit('touchClickItem', clearCloseTimeout)
      }

      if (!collapsedItem && this.item.children) {
        if (this.isCollapsed && this.firstItem) {
          event.preventDefault()
          return
        }

        this.toggleDropdown()
      }
    }
  },

  computed: {
    show () {
      if (!this.item || !this.item.children) {
        return false
      }

      return this.itemShow
    }
  },

  watch: {
    $route () {
      this.active = this.item && this.item.href ? this.isLinkActive(this.item) : false
      this.childActive = this.item && this.item.children ? this.isChildActive(this.item.children) : false
    }
  },

  inject: ['showChildren']
}

export const animationMixin = {
  methods: {
    expandEnter (el) {
      el.style.height = el.scrollHeight + 'px'
    },

    expandAfterEnter (el) {
      el.style.height = 'auto'
    },

    expandBeforeLeave (el) {
      if (this.isCollapsed) {
        el.style.display = 'none'
        return
      }

      el.style.height = el.scrollHeight + 'px'
    }
  }
}
